/**
 * FarmSection (HOF-627 R6, §4, §6) — Settings → Betrieb: the farm's own name and identity,
 * the farm switcher and deleting the farm — and, at its end, deleting the person's own account
 * (while impersonating, the viewed person's — HOF-708).
 *
 * Since the settings refactor this is the Betrieb **pane** (`/settings/farm`), mounted only while
 * open, so its reads (``FarmSettingsPanel``) run only for someone looking at it.
 */
import { useTranslation } from 'react-i18next';
import { SettingsPane } from '@hofsync/design-system';
import AccountDeletionSection from './AccountDeletionSection';
import FarmSettingsPanel from './FarmSettingsPanel';
import type { FarmSummary } from '../../contexts/AuthContext';
import type { SettingsPaneChrome } from './paneChrome';

export interface FarmSectionProps extends SettingsPaneChrome {
    farms: FarmSummary[];
    activeTenantId: string | null;
    onSwitched: () => void;
}

export default function FarmSection({ backLink, focusOnMount, ...props }: FarmSectionProps) {
    const { t } = useTranslation();
    return (
        <SettingsPane
            title={t('settings.farm.title', 'Betrieb')}
            description={t('settings.farm.subtitle', 'Name und Angaben deines Betriebs.')}
            backLink={backLink}
            focusOnMount={focusOnMount}
        >
            <FarmSettingsPanel {...props} />
            <AccountDeletionSection />
        </SettingsPane>
    );
}
